import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import { getFileUrl } from "../../api/file";

export default function ClientTile({ client }) {
    return (
        <Link to={`/clients/${client.id}`}>
            <div className="flex h-[48px]  items-center space-x-4  w-full px-[16px] my-1 text-black">
                <Avatar
                    src={client.avatar ? getFileUrl(client.avatar) : null}
                    size={24}
                    icon={<UserOutlined className="h-full w-full flex text-sm justify-center " />}
                />
                <p className="font-medium text-sm">{client.name} <span className="font-normal"></span> </p>
            </div>
        </Link>);
}
